<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="出入类型">
        <el-select v-model="query.inOutType" size="small" clearable style="width:110px">
          <el-option label="全部" value="all" /><el-option label="入库" value="in" /><el-option label="出库" value="out" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间"><el-date-picker v-model="query.start" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width:180px" /></el-form-item>
      <el-form-item label="结束时间"><el-date-picker v-model="query.end" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width:180px" /></el-form-item>
      <el-form-item label="单据编号"><el-input v-model="query.code" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:inOutDetail:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('inventory:inOutDetail:list')" type="primary" size="small" @click="exportFile">导出</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="bizDate" label="业务时间" width="170" />
      <el-table-column prop="direction" label="出入类型" width="90">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.direction === 'in' ? 'success' : 'danger'">{{ scope.row.direction === 'in' ? '入库' : '出库' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="bizTypeName" label="单据类型" width="130" />
      <el-table-column prop="bizCode" label="单据编号" min-width="150" />
      <el-table-column prop="materialCode" label="产品编码" min-width="120" />
      <el-table-column prop="materialName" label="产品名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格型号" min-width="110" show-overflow-tooltip />
      <el-table-column prop="quantity" label="数量" width="100" align="right" />
      <el-table-column prop="wareHouseName" label="仓库" min-width="120" show-overflow-tooltip />
      <el-table-column prop="partnerName" label="往来单位" min-width="150" show-overflow-tooltip />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
export default {
  name: 'InOutDetail',
  mixins: [authMixin],
  data() { return { query: { code: '', materialCode: '', materialName: '', inOutType: 'all', start: '', end: '' }, rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false } },
  created() { this.load() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { code: '', materialCode: '', materialName: '', inOutType: 'all', start: '', end: '' }; this.search() },
    params() {
      return { keyword: this.query.code, materialCode: this.query.materialCode, materialName: this.query.materialName, inOutType: this.query.inOutType, start: this.query.start, end: this.query.end, pageIndex: this.pageIndex, pageSize: this.pageSize }
    },
    exportFile() {
      const params = this.params()
      delete params.pageIndex
      delete params.pageSize
      request.get('/inventory/inOutDetail/export', { params, responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '出入明细.xlsx'
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(() => {})
    },
    load() {
      this.loading = true
      request.get('/inventory/inOutDetail/list', { params: this.params() }).then(res => {
        const body = res.data || {}
        this.rows = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.title-actions { float: right; margin-right: 28px; }
.line-tools { margin-bottom: 10px; }
.cards { margin-bottom: 12px; }
.card-num { font-size: 28px; font-weight: 600; margin-top: 8px; }
</style>
